import api from "./api";

const RoleMasterService = {
  getAllRoles: async () => {
    try {
      const response = await api.get("/roleMaster/get");
      return response.data;
    } catch (error) {
      console.error("Error fetching roles:", error);
      throw error;
    }
  },
};

export default RoleMasterService;